import { render, staticRenderFns } from "./Faces.vue?vue&type=template&id=7b9f6ef0&scoped=true&"
var script = {}
import style0 from "./Faces.vue?vue&type=style&index=0&id=7b9f6ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9f6ef0",
  null
  
)

export default component.exports